import Presence from "./PresenceChannel";
import User from "./UserChannel";

export const PresenceChannel = Presence;
export const UserChannel = User;